// Ngan hang lien ket tren Player 360 doc tu ban sao game DB (cham 9-20 s so voi he A). Sau khi sua / them /
// go / xac minh, panel phu dong he A vua ghi len danh sach cu cho toi khi ban sao giong (hoac het han), de
// admin thay ngay gia tri moi thay vi bam lai (task sua-nh-sub).
export type BankRow = { id: number; ma_nh: string; ten_nh: string; so_tk: string; ten_tk: string; trang_thai: string; tao_luc: string; xac_minh_luc?: string | null; xac_minh_boi?: string | null };
export type Fresh = { id: number; patch: Partial<BankRow>; at: number };

export const FRESH_MAX_MS = 120_000;

// xac_minh_luc: ban sao co gio cua he A, phu chi biet co / khong
const giong = (k: string, a: unknown, b: unknown) => (k === 'xac_minh_luc' ? !!a === !!b : a === b);
const khop = (r: BankRow, f: Fresh) => Object.entries(f.patch).every(([k, v]) => giong(k, (r as Record<string, unknown>)[k], v));

/** The list the panel shows and the overrides still waiting for the replica. */
export function layFresh(banks: BankRow[], fresh: Fresh[], now: number, maxMs = FRESH_MAX_MS): { banks: BankRow[]; live: Fresh[] } {
  const live = fresh.filter((f) => now - f.at < maxMs && !banks.some((r) => r.id === f.id && khop(r, f)));
  const out = banks.map((r) => live.filter((f) => f.id === r.id).reduce<BankRow>((x, f) => ({ ...x, ...f.patch }), r));
  // a row the replica does not have yet (first account added): newest first, like the API's ORDER BY id DESC
  const moi = live.filter((f) => !banks.some((r) => r.id === f.id) && f.patch.ma_nh != null && f.patch.so_tk != null)
    .map((f) => ({ tao_luc: new Date(f.at).toISOString(), trang_thai: 'dung', ten_nh: '', ten_tk: '', ...f.patch, id: f.id }) as BankRow);
  return { banks: [...moi.sort((a, b) => b.id - a.id), ...out], live };
}

/** Adds or replaces the override of one row (the latest change of a row wins). */
export function themFresh(fresh: Fresh[], id: number, patch: Partial<BankRow>, now: number): Fresh[] {
  const cu = fresh.find((f) => f.id === id);
  return [...fresh.filter((f) => f.id !== id), { id, patch: { ...(cu?.patch ?? {}), ...patch }, at: now }];
}
